module.exports = __webpack_public_path__ + "img/table.69ab4536.png";